export interface IDepositsToRedeem {
  redeemed: number;
  outstanding: number;
}